import React, { useState, useEffect } from "react";

const FillInTheBlanksInput = ({ sentence, options, submitted, onSubmit, onRetake, onIsAttempted }) => {
  const [parts, setParts] = useState([]);
  const [placeholderIndices, setPlaceholderIndices] = useState([]);
  const [userInput, setUserInput] = useState([]);

  useEffect(() => {
    if (sentence) {
      const partsArray = sentence.split(/(__add_blank__|<span[^>]*>.*?<\/span>)/);
      setParts(partsArray);

      const indicesArray = partsArray
        .map((part, index) => (part.startsWith("<span") ? index : null))
        .filter((index) => index !== null);
      setPlaceholderIndices(indicesArray);

      // Initialize userInput as an array of empty strings based on the number of placeholders
      const initialUserInput = Array(indicesArray.length).fill("");
      setUserInput(initialUserInput);
    }
  }, [sentence]);

  const handleInputChange = (event, index) => {
    const option = event.target.value;
    // Update the corresponding index in userInput with the new option
    const updatedUserInput = [...userInput];
    updatedUserInput[index] = option.trim();
    setUserInput(updatedUserInput);

    // Pass user input changes back to parent component
    onSubmit(updatedUserInput);
  };

  const handleSubmit = () => {
    const areAnswersCorrect = userInput.every((userAnswer, index) => {
      const correctAnswer = getCorrectAnswer(index);
      return userAnswer.trim() === correctAnswer.trim();
    });

    onIsAttempted(true);
    onSubmit(userInput, areAnswersCorrect); // Ensure to pass the userInput and correctness status
  };

  const handleRetake = () => {
    onIsAttempted(false);
    onRetake();
    setUserInput(Array(placeholderIndices.length).fill(""));
  };

  const getCorrectAnswer = (index) => {
    const spanPart = parts[placeholderIndices[index]];
    if (spanPart) {
      const correctAnswer = spanPart.match(/<span[^>]*>(.*?)<\/span>/);
      if (correctAnswer && correctAnswer.length > 1) {
        return correctAnswer[1].trim();
      }
    }
    return "";
  };

  useEffect(() => {
    // Clear userInput when submitted status changes to false and retake is triggered
    if (!submitted) {
      setUserInput(Array(placeholderIndices.length).fill(""));
    }
  }, [submitted, placeholderIndices.length]);

  return (
    <div className="bg-white mx-3">
      <form onSubmit={(e) => e.preventDefault()}>
        <p className="my-4 px-6 py-4 text-justify">
          {parts.map((part, index) => {
            if (part.startsWith("<span") && part.endsWith("</span>")) {
              const placeholderIndex = placeholderIndices.indexOf(index);
              return (
                <input
                  key={index}
                  type="text"
                  onChange={(event) => handleInputChange(event, placeholderIndex)}
                  value={userInput[placeholderIndex]}
                  className={`inline-block px-2 py-1 bg-gray-200 border border-gray-300 rounded-sm m-1 ${
                    part.length > 10 ? "w-20" : "w-12"
                  } ${
                    submitted && userInput[placeholderIndex].trim() === getCorrectAnswer(placeholderIndex).trim()
                      ? "bg-green-300"
                      : submitted && userInput[placeholderIndex].trim() !== getCorrectAnswer(placeholderIndex).trim()
                      ? "bg-red-300"
                      : ""
                  }`}
                  disabled={submitted}
                />
              );
            } else if (!part.includes("__add_blank__")) {
              return <span key={index}>{part}</span>;
            } else {
              return null;
            }
          })}
        </p>
      </form>
    </div>
  );
};

export default FillInTheBlanksInput;
